// Gestion de l'expand collapse en version mobile
var footerExpandCollapse = function () {
    if ($(window).outerWidth() < evostrap.breakpoints.md) {
        $('footer .collapse').removeClass('show');
    } else {
        $('footer .collapse').addClass('show');
    }
};
footerExpandCollapse();
$(window).on("resize", function () { footerExpandCollapse() });





// Gestion des liens présents dans un séparateur
$('.separator a').on("click", function (e) {
    if (this.hash) {
        e.preventDefault();

    }

});
// Activer le focus sur le premier lien lorsque l'utilisateur ouvre le menu
$('#website-links-items, #europarl-links').on('shown.bs.collapse', function () {
    $(this).find(evostrap.focusable).first().trigger("focus");
})